import { useState } from 'react';

export default function CarsUnder10kFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Are cars under $10k reliable?',
      answer: 'Depends on who\'s selling them. A well-maintained 2010 Toyota with 150k miles? Absolutely. A 2015 luxury car with a sketchy history and no service records? Run. We only stock the former. High mileage doesn\'t scare us — neglect does.'
    },
    {
      question: 'What should I look for in a budget car?',
      answer: 'Service history first, everything else second. We\'d rather sell you a boring Corolla with a binder full of oil change receipts than a "fun" car that was owned by someone who thought maintenance was optional. Also: check the tires. Bald tires are a red flag that the previous owner cut corners everywhere.'
    },
    {
      question: 'Do you offer financing for cars under $10k?',
      answer: 'Yep. We work with local credit unions who actually understand that a $8,000 car loan is still a real loan. No predatory "buy here, pay here" nonsense. If you can afford the payment, we\'ll help you get approved.'
    },
    {
      question: 'What if something breaks after I buy it?',
      answer: 'We\'re not going to pretend a 12-year-old car will never need repairs. But we do a thorough inspection before we sell it, and we\'ll tell you upfront if something is on its way out. No surprises. And if you need a mechanic recommendation, we know all the good ones.'
    },
    {
      question: 'Why are your prices higher than Craigslist?',
      answer: 'Because we actually inspect the cars, fix what needs fixing, and stand behind what we sell. Craigslist is great if you know exactly what you\'re looking at. But if you don\'t want to gamble on whether "runs great" means "starts most of the time," we\'re worth the extra $500.'
    },
    {
      question: 'Can I negotiate the price?',
      answer: 'Not really. We price our cars fairly from the start based on condition, market value, and what we have into them. We\'re not playing the "list it high and haggle down" game. The price you see is the price you pay — no hidden fees, no surprises.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-[#1C2B1E] mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-gray-600">
              Everything you need to know about buying a car under $10K
            </p>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => {
              const btnId = `u10k-faq-btn-${index}`;
              const panelId = `u10k-faq-panel-${index}`;
              const isOpen = openIndex === index;
              return (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-md overflow-hidden"
                >
                  <button
                    id={btnId}
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#1E3A5F]"
                  >
                    <span className="text-lg font-bold text-[#1C2B1E] pr-4">
                      {faq.question}
                    </span>
                    <i
                      aria-hidden="true"
                      className={`ri-arrow-down-s-line text-2xl text-[#E8B84B] transition-transform flex-shrink-0 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </button>

                  {isOpen && (
                    <div
                      id={panelId}
                      role="region"
                      aria-labelledby={btnId}
                      className="px-6 pb-5"
                    >
                      <p className="text-gray-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}